import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-right",
  "use": "icon-arrow-right-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-arrow-right\"><g fill=\"none\" fill-rule=\"evenodd\"><path d=\"M0 16V0h16v16z\" /><path fill=\"currentColor\" fill-rule=\"nonzero\" d=\"m4.793 3.053 1.414-1.414 6.364 6.364-6.364 6.364-1.414-1.414 4.949-4.949z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol